import { useMemo } from 'react';

import { Alert } from '@simplywallst/ui-core';

import { getErrorMessage } from './utils';

type Props = {
  error: unknown;
  transaction: { tickerSymbol: string };
};

export const Error = ({ error, transaction }: Props) => {
  const message = useMemo(
    () => getErrorMessage(error, transaction),
    [error, transaction]
  );

  return <Alert styleType="negative">{message}</Alert>;
};
